import React, { useState } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifFormField,
  MotifLabel,
  MotifInput,
  MotifErrorMessage,
  MotifTooltip,
} from '@ey-xd/motif-react';
import { ModalHeaderContainer } from '@organisms/modals/styles/plOpportunityNameModal.styles';
import { SUPER_USER_CONST } from '@constants/commonConstants';
import { useSetRecoilState } from 'recoil';
import { Open_Super_User_Modal_State, Full_Page_Loading_State } from '@recoil/recoil';
import { navigateTo } from '@services/navigationService';
import { getDashboardProfileDetails, getUserRole } from '@services/commonServices';
import { logError } from '@util/commonFunctions';
import { useLocation } from 'react-router-dom';

const SuperUserModal = () => {
  const [showModal, setShowModal] = useState(true);
  const [email, setEmail] = useState('');
  // Error Messages states
  const [isValid, setIsValid] = useState(true);
  const [isAccessDenied, setIsAccessDenied] = useState(false);
  const [isForbiddenAccess, setIsForbiddenAccess] = useState(false);
  const [isProfileApiFailed, setIsProfileApiFailed] = useState(false);
  const [isSameUserEmail, setIsSameUserEmail] = useState(false);
  const [isSameTargetUserEmail, setIsSameTargetUserEmail] = useState(false);
  const [isSameSessionUserEmail, setIsSameSessionUserEmail] = useState(false);

  const setIsFullPageLoading = useSetRecoilState(Full_Page_Loading_State);
  const setOpenSuperUserModal = useSetRecoilState(Open_Super_User_Modal_State);

  const location = useLocation();

  const onCloseModal = () => {
    setShowModal(false);
    setOpenSuperUserModal(false);
  };

  const onResetClicked = () => {
    // setOpenSuperUserModal(false);
    localStorage.setItem('targetUserEmail', null);
    localStorage.removeItem('selectedUser');
    navigateTo('/');
    window.location.reload();
  };

  const onSubmitClick = async enteredEmail => {
    if (
      enteredEmail.toLowerCase() == localStorage.getItem('userEmail').toLowerCase() &&
      localStorage.getItem('targetUserEmail') == 'null'
    ) {
      setIsSameSessionUserEmail(true);
      return;
    }

    if (enteredEmail.toLowerCase() == localStorage.getItem('userEmail').toLowerCase()) {
      setIsSameUserEmail(true);
      return;
    }

    if (enteredEmail.toLowerCase() == localStorage.getItem('targetUserEmail').toLowerCase()) {
      setIsSameTargetUserEmail(true);
      return;
    }

    localStorage.setItem('checkingForRoleList', true);
    setEmail(email);
    setIsFullPageLoading(true);
    await getDashboardProfileDetails(enteredEmail)
      .then(result => {
        fetchUserRole(enteredEmail, result?.country);
      })
      .catch(error => {
        logError('getDashboardProfileDetails', error);
        setIsProfileApiFailed(true);
        setIsFullPageLoading(false);
        localStorage.setItem('checkingForRoleList', false);
      });
  };

  const fetchUserRole = async (userEmail, countryName) => {
    const userRoleDetails = await getUserRole(userEmail, countryName);
    const userRoleList = userRoleDetails?.roleList;
    if (!userRoleDetails?.hasRoleAccess) {
      setIsAccessDenied(true);
      setIsFullPageLoading(false);
      localStorage.setItem('checkingForRoleList', false);
    } else if (userRoleList === undefined || userRoleList?.length === 0) {
      setIsForbiddenAccess(true);
      setIsFullPageLoading(false);
      localStorage.setItem('checkingForRoleList', false);
    } else {
      localStorage.setItem('targetUserEmail', email);
      localStorage.removeItem('selectedUser');
      setIsFullPageLoading(false);
      localStorage.setItem('checkingForRoleList', false);

      navigateTo('/');
      window.location.reload();
    }
  };

  const validateEmail = email => {
    setEmail(email);
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setIsValid(regex.test(String(email).toLowerCase()));
  };

  return (
    <>
      <MotifModal
        variant="alt"
        show={showModal}
        onClose={onCloseModal}
        focusTrapOptions={{
          initialFocus: false,
        }}
      >
        <MotifModalHeader
          title="Close opportunity details modal"
          closeModalButton={location.pathname == '/super-user' ? true : false}
        >
          <ModalHeaderContainer>{SUPER_USER_CONST.TITLE}</ModalHeaderContainer>
        </MotifModalHeader>
        <MotifModalBody>
          <p>Enter the User Email Id:</p>
          <MotifFormField>
            <MotifLabel>Email</MotifLabel>
            <MotifInput
              type="email"
              value={email}
              onChange={event => {
                validateEmail(event.target.value);
                setIsAccessDenied(false);
                setIsForbiddenAccess(false);
                setIsProfileApiFailed(false);
                setIsSameUserEmail(false);
                setIsSameSessionUserEmail(false);
                setIsSameTargetUserEmail(false);
              }}
              required
            />
            {/* Error Messages */}

            {!isValid && (
              <MotifErrorMessage> {SUPER_USER_CONST.IS_VALID_EMAIL_MESSAGE}</MotifErrorMessage>
            )}
            {isAccessDenied && (
              <MotifErrorMessage>{SUPER_USER_CONST.IS_ACCESS_DENIED_MESSAGE}</MotifErrorMessage>
            )}
            {isForbiddenAccess && (
              <MotifErrorMessage>{SUPER_USER_CONST.IS_FORBIDDEN_ACCESS_MESSAGE}</MotifErrorMessage>
            )}
            {isProfileApiFailed && (
              <MotifErrorMessage>
                {SUPER_USER_CONST.IS_PROFILE_API_FAILED_MESSAGE}
              </MotifErrorMessage>
            )}
            {isSameUserEmail && (
              <MotifErrorMessage>{SUPER_USER_CONST.IS_SAME_USER_MESSAGE}</MotifErrorMessage>
            )}
            {isSameSessionUserEmail && (
              <MotifErrorMessage>{SUPER_USER_CONST.IS_SAME_SESSION_USER_MESSAGE}</MotifErrorMessage>
            )}
            {isSameTargetUserEmail && (
              <MotifErrorMessage>{SUPER_USER_CONST.IS_SAME_TARGET_USER_MESSAGE}</MotifErrorMessage>
            )}
          </MotifFormField>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            disabled={!isValid || email == ''}
            type="button"
            variant="secondary"
            style={{ backgroundColor: '#ffe600' }}
            onClick={() => {
              onSubmitClick(email);
            }}
          >
            {SUPER_USER_CONST.SUBMIT_BUTTON_TITLE}
          </MotifButton>
          {localStorage.getItem('targetUserEmail') != 'null' && (
            <MotifButton variant="secondary" type="button" onClick={onResetClicked}>
              <MotifTooltip
                id="bottom"
                trigger={SUPER_USER_CONST.RESET_BUTTON}
                allowHover={true}
                allowClick={true}
                placement="bottom"
              >
                Reset user to :- {localStorage.getItem('userEmail')}
              </MotifTooltip>
            </MotifButton>
          )}
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};

export default SuperUserModal;
